/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinition extends models.BaseDefinition {
    getFixupPrototypeFunction() { return DashboardDefinition.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinition>): DashboardDefinition {
        let obj = Object.assign(new DashboardDefinition(), model);
        DashboardDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinition>): DashboardDefinition {
        if (!model) return null;
        return DashboardDefinition.newInstance(<DashboardDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinition) {
        if (!obj) return;

        models.DashboardDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinition): boolean {
        if (models.BaseDefinition.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.user) {
            models.RecordIdentity.fixupPrototype(this.user);
        }
    }

    user: models.RecordIdentity;

}
